import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { getError } from "@/app/utils/helpers";
import { useGlobalContext } from "@/global/GlobalContext";
import { logOut } from "@/app/redux/features/auth/authSlice";
import Arrow from "@/assets/icons/triangle-03.webp"
import UserProfile from "./UserProfile";
import ProcessModal from "../../../components/ProcessModal";

const SidebarUser = () => {
  const { authStore, pathname, processSaveModal, setProcessSaveModal } = useGlobalContext()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const userData = authStore.user
  const arrowImgRef = useRef(null)
  const [modalContent, setModalContent] = useState(null)

  useEffect(() => {
    const navbarLinks = document.getElementsByClassName("sidebar__link")
    const accountLink = document.getElementById("accountLink")
    for (let navLink of navbarLinks) {
      if (pathname == navLink.getAttribute("href")) {
        if (navLink.parentElement.classList.contains("sidebar-link__sub")) {
          accountLink.classList.add("text-[#bc9c5c]")
          accountLink.classList.remove("text-[#d0c1a3]")
        }
        navLink.classList.add("text-[#bc9c5c]")
        navLink.classList.remove("text-[#d0c1a3]")
      }
    }
  }, [pathname])

  const handleLogOut = () => {
    setModalContent({ title: "Confirmation", msg: "Are you sure to log out?", isOpen: true, isConfirm: true })
  }

  const logOutUser = async () => {
    try {
      const res = await dispatch(logOut()).unwrap()
      if (res.code == 200) {
        navigate("/auth/login")
      }
      setProcessSaveModal(false)
    } catch (err) {
      return getError(err)
    }
  }

  const toggleSidebar = () => {
    const sidebarMenu = document.getElementById("sidebarMenuContainer")
    sidebarMenu.classList.toggle("max-sm:h-0")
    sidebarMenu.classList.toggle("max-sm:h-32")
  }

  const toggleAccountMenu = () => {
    arrowImgRef.current.classList.toggle("rotate-180")
    const accountMenu = document.getElementById("accountMenu")
    accountMenu.classList.toggle("h-0")
  }

  return (
    <>
      <ProcessModal pModalContent={modalContent} processModal={logOutUser} />
      <div className="max-sm:mb-2.5 w-full sm:w-[23%] lg:w-1/5 sm:pr-5 lg:pr-10">
        <div className="max-sm:border-b-[1px] max-sm:border-b-[#bc9c5c] max-sm:py-5 max-sm:flex max-sm:justify-between max-sm:items-center">
          <UserProfile toggleSidebar={toggleSidebar} userData={userData} custNameCls="text-[16px] lg:text-[24px] leading-[16px] lg:leading-[24px]" />
          {/* <div className="sm:hidden">
                  <FontAwesomeIcon icon={faBell} size="xl" style={{ color: "#bc9c5c" }} />
                </div> */}
        </div>
        <div id="sidebarMenuContainer" className="max-md:overflow-hidden max-md:transition-[height] max-md:duration-1000 max-md:ease-in-out max-sm:h-0 max-sm:mt-2.5 sm:mt-8 px-3">
          <ul>
            <li>
              <button onClick={toggleAccountMenu} id="accountLink" type="button" className="max-md:mb-1 text-[#d0c1a3] hover:text-[#bc9c5c] font-agcasmlt font-light text-lg lg:text-xl">Account
                <img ref={arrowImgRef} width="13" src={Arrow} alt="" className="inline-block ml-1 -mt-1" />
              </button>
              <ul id="accountMenu" className="overflow-hidden transition-[height] duration-1000 ease-in-out ml-1 h-0">
                <li className="max-md:mb-1 sidebar-link__sub font-light font-agcasmlt text-xs sm:text-sm block text-[#d0c1a3] hover:text-[#bc9c5c] cursor-pointer">
                  <Link to="/user/dashboard/profile" className="sidebar__link">Profile</Link></li>
                <li className="max-md:mb-1 sidebar-link__sub font-light font-agcasmlt text-xs sm:text-sm block text-[#d0c1a3] hover:text-[#bc9c5c] cursor-pointer">
                  <Link to="/user/dashboard/change-password" className="sidebar__link">Change Password</Link></li>
              </ul>
            </li>
            <li className="max-md:mb-1 text-[#d0c1a3] hover:text-[#bc9c5c] font-agcasmlt font-light text-lg lg:text-xl">
              <Link to="/user/dashboard/my-purchase" className="sidebar__link">My Purchase</Link>
            </li>
            {/* <li className="">
                    <span className="text-[#bc9c5c] font-agcasmlt font-light text-lg lg:text-xl">Notifications</span>
                    <img width="13" src={Arrow} alt="" className="inline-block ml-1 -mt-1" />
                  </li> */}
            <li className="sidebar__link text-[#d0c1a3] hover:text-[#bc9c5c] font-agcasmlt font-light text-lg lg:text-xl">
              <button type="button" onClick={handleLogOut}>Log Out</button>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default SidebarUser